import React, { useState, useEffect } from 'react';
import { Flex, Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import EmissionService from "../../../services/EmissionService";
import EmissionString from "./EmissionString";
import cl from "../../Data/style.module.css";

const DataTable2 = () => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const limit = 30;

    const { t } = useTranslation();

    const emissionFields = [
        { key: 'no', name: 'NO_mgm3' },
        { key: 'noGs', name: 'NO_gs' },
        { key: 'no2', name: 'NO2_mgm3' },
        { key: 'no2Gs', name: 'NO2_gs' },
        { key: 'co', name: 'CO_mgm3' },
        { key: 'coGs', name: 'CO_gs' },
        { key: 'so2', name: 'SO2_mgm3' },
        { key: 'so2Gs', name: 'SO2_gs' },
        { key: 'dust', name: 'DUST' },
        { key: 'o2', name: 'O2' },
        { key: 'pt', name: 'PT' },
        { key: 'temp', name: 'TEMP' },
        { key: 'hum', name: 'HUMIDITY' },
        { key: 'flowsk', name: 'FLOW' },
    ];

    const fetchData = async (page) => {
        setIsLoading(true);
        await EmissionService.getEmissionsActualPageable(page, limit)
            .then((r) => {
                setData(r.data.list);
                setHasMore(r.data.hasMore);
            })
            .finally(() => {
                setIsLoading(false);
            })
    };

    useEffect(() => {
        fetchData(page);
    }, [page]);

    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}.${month}.${year} ${hours}:${minutes}`;
    };

    const handlePrevPage = () => setPage((p) => Math.max(p - 1, 0));
    const handleNextPage = () => setPage((p) => p + 1);

    return (
        <Flex vertical gap={10} style={{marginBottom: 50}}>
            <Flex justify="center" gap={10}>
                <Button onClick={handlePrevPage} disabled={page === 1}>
                    <LeftOutlined />
                </Button>
                <Button onClick={handleNextPage} disabled={!hasMore}>
                    <RightOutlined />
                </Button>
            </Flex>

            <div style={{ overflowX: 'auto' }}>
                <table className={cl.dataTable}>
                    <thead>
                    <tr>
                        <th style={{backgroundColor: '#FF4C15'}}>{t('dataPage.time')}</th>
                        {emissionFields.map((field) => (
                            <th key={field.key} style={{backgroundColor: '#FF4C15'}}>
                                <EmissionString emission={{ name: field.name }} />
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {data.map((row, index) => (
                        <tr key={row.id} className={index % 2 === 0 ? cl.evenRow : cl.oddRow}>
                            <td style={{backgroundColor: '#EEC02D', color: "white"}}>{formatTimestamp(row.time)}</td>
                            {emissionFields.map((field) => (
                                <td key={field.key} style={{ color: 'black' }}>
                                    {row[field.key] !== undefined ? row[field.key].toFixed(2) : ''}
                                </td>
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </Flex>
    );
};

export default DataTable2;